/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ActualAssetClassExposureMaxLimitViewModel } from './ActualAssetClassExposureMaxLimitViewModel';
import {
    ActualAssetClassExposureMaxLimitViewModelFromJSON,
    ActualAssetClassExposureMaxLimitViewModelFromJSONTyped,
    ActualAssetClassExposureMaxLimitViewModelToJSON,
} from './ActualAssetClassExposureMaxLimitViewModel';
import type { ActualAssetClassExposureResponseViewModel } from './ActualAssetClassExposureResponseViewModel';
import {
    ActualAssetClassExposureResponseViewModelFromJSON,
    ActualAssetClassExposureResponseViewModelFromJSONTyped,
    ActualAssetClassExposureResponseViewModelToJSON,
} from './ActualAssetClassExposureResponseViewModel';
import type { ActualAssetClassExposureWeightsViewModel } from './ActualAssetClassExposureWeightsViewModel';
import {
    ActualAssetClassExposureWeightsViewModelFromJSON,
    ActualAssetClassExposureWeightsViewModelFromJSONTyped,
    ActualAssetClassExposureWeightsViewModelToJSON,
} from './ActualAssetClassExposureWeightsViewModel';
import type { ActualRegionalExposureMaxLimitViewModel } from './ActualRegionalExposureMaxLimitViewModel';
import {
    ActualRegionalExposureMaxLimitViewModelFromJSON,
    ActualRegionalExposureMaxLimitViewModelFromJSONTyped,
    ActualRegionalExposureMaxLimitViewModelToJSON,
} from './ActualRegionalExposureMaxLimitViewModel';
import type { ActualRegionalExposureResponseViewModel } from './ActualRegionalExposureResponseViewModel';
import {
    ActualRegionalExposureResponseViewModelFromJSON,
    ActualRegionalExposureResponseViewModelFromJSONTyped,
    ActualRegionalExposureResponseViewModelToJSON,
} from './ActualRegionalExposureResponseViewModel';
import type { ActualRegionalExposureWeightsViewModel } from './ActualRegionalExposureWeightsViewModel';
import {
    ActualRegionalExposureWeightsViewModelFromJSON,
    ActualRegionalExposureWeightsViewModelFromJSONTyped,
    ActualRegionalExposureWeightsViewModelToJSON,
} from './ActualRegionalExposureWeightsViewModel';
import type { InfrastructureExposureMaxLimitViewModel } from './InfrastructureExposureMaxLimitViewModel';
import {
    InfrastructureExposureMaxLimitViewModelFromJSON,
    InfrastructureExposureMaxLimitViewModelFromJSONTyped,
    InfrastructureExposureMaxLimitViewModelToJSON,
} from './InfrastructureExposureMaxLimitViewModel';
import type { InfrastructureExposureWeightsViewModel } from './InfrastructureExposureWeightsViewModel';
import {
    InfrastructureExposureWeightsViewModelFromJSON,
    InfrastructureExposureWeightsViewModelFromJSONTyped,
    InfrastructureExposureWeightsViewModelToJSON,
} from './InfrastructureExposureWeightsViewModel';
import type { InfrastrucureExposureResponseViewModel } from './InfrastrucureExposureResponseViewModel';
import {
    InfrastrucureExposureResponseViewModelFromJSON,
    InfrastrucureExposureResponseViewModelFromJSONTyped,
    InfrastrucureExposureResponseViewModelToJSON,
} from './InfrastrucureExposureResponseViewModel';

/**
 * 
 * @export
 * @interface PolicyExposureResponseViewModel
 */
export interface PolicyExposureResponseViewModel {
    /**
     * 
     * @type {Array<ActualAssetClassExposureResponseViewModel>}
     * @memberof PolicyExposureResponseViewModel
     */
    actualAssetClassExposure?: Array<ActualAssetClassExposureResponseViewModel>;
    /**
     * 
     * @type {Array<ActualRegionalExposureResponseViewModel>}
     * @memberof PolicyExposureResponseViewModel
     */
    actualRegionalExposure?: Array<ActualRegionalExposureResponseViewModel>;
    /**
     * 
     * @type {Array<InfrastrucureExposureResponseViewModel>}
     * @memberof PolicyExposureResponseViewModel
     */
    infrastrucureExposure?: Array<InfrastrucureExposureResponseViewModel>;
    /**
     * 
     * @type {ActualAssetClassExposureWeightsViewModel}
     * @memberof PolicyExposureResponseViewModel
     */
    actualAssetClassExposureWeigths?: ActualAssetClassExposureWeightsViewModel;
    /**
     * 
     * @type {ActualRegionalExposureWeightsViewModel}
     * @memberof PolicyExposureResponseViewModel
     */
    actualRegionalExposureWeights?: ActualRegionalExposureWeightsViewModel;
    /**
     * 
     * @type {InfrastructureExposureWeightsViewModel}
     * @memberof PolicyExposureResponseViewModel
     */
    infrastrucureExposureWeights?: InfrastructureExposureWeightsViewModel;
    /**
     * 
     * @type {ActualAssetClassExposureMaxLimitViewModel}
     * @memberof PolicyExposureResponseViewModel
     */
    actualAssetClassExposureMaxLimits?: ActualAssetClassExposureMaxLimitViewModel;
    /**
     * 
     * @type {InfrastructureExposureMaxLimitViewModel}
     * @memberof PolicyExposureResponseViewModel
     */
    infrastrucureExposureMaxLimits?: InfrastructureExposureMaxLimitViewModel;
    /**
     * 
     * @type {ActualRegionalExposureMaxLimitViewModel}
     * @memberof PolicyExposureResponseViewModel
     */
    actualRegionalExposureMaxLimits?: ActualRegionalExposureMaxLimitViewModel;
}

/**
 * Check if a given object implements the PolicyExposureResponseViewModel interface.
 */
export function instanceOfPolicyExposureResponseViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PolicyExposureResponseViewModelFromJSON(json: any): PolicyExposureResponseViewModel {
    return PolicyExposureResponseViewModelFromJSONTyped(json, false);
}

export function PolicyExposureResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PolicyExposureResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actualAssetClassExposure': !exists(json, 'ActualAssetClassExposure') ? undefined : ((json['ActualAssetClassExposure'] as Array<any>).map(ActualAssetClassExposureResponseViewModelFromJSON)),
        'actualRegionalExposure': !exists(json, 'ActualRegionalExposure') ? undefined : ((json['ActualRegionalExposure'] as Array<any>).map(ActualRegionalExposureResponseViewModelFromJSON)),
        'infrastrucureExposure': !exists(json, 'InfrastrucureExposure') ? undefined : ((json['InfrastrucureExposure'] as Array<any>).map(InfrastrucureExposureResponseViewModelFromJSON)),
        'actualAssetClassExposureWeigths': !exists(json, 'ActualAssetClassExposureWeigths') ? undefined : ActualAssetClassExposureWeightsViewModelFromJSON(json['ActualAssetClassExposureWeigths']),
        'actualRegionalExposureWeights': !exists(json, 'ActualRegionalExposureWeights') ? undefined : ActualRegionalExposureWeightsViewModelFromJSON(json['ActualRegionalExposureWeights']),
        'infrastrucureExposureWeights': !exists(json, 'InfrastrucureExposureWeights') ? undefined : InfrastructureExposureWeightsViewModelFromJSON(json['InfrastrucureExposureWeights']),
        'actualAssetClassExposureMaxLimits': !exists(json, 'ActualAssetClassExposureMaxLimits') ? undefined : ActualAssetClassExposureMaxLimitViewModelFromJSON(json['ActualAssetClassExposureMaxLimits']),
        'infrastrucureExposureMaxLimits': !exists(json, 'InfrastrucureExposureMaxLimits') ? undefined : InfrastructureExposureMaxLimitViewModelFromJSON(json['InfrastrucureExposureMaxLimits']),
        'actualRegionalExposureMaxLimits': !exists(json, 'ActualRegionalExposureMaxLimits') ? undefined : ActualRegionalExposureMaxLimitViewModelFromJSON(json['ActualRegionalExposureMaxLimits']),
    };
}

export function PolicyExposureResponseViewModelToJSON(value?: PolicyExposureResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ActualAssetClassExposure': value.actualAssetClassExposure === undefined ? undefined : ((value.actualAssetClassExposure as Array<any>).map(ActualAssetClassExposureResponseViewModelToJSON)),
        'ActualRegionalExposure': value.actualRegionalExposure === undefined ? undefined : ((value.actualRegionalExposure as Array<any>).map(ActualRegionalExposureResponseViewModelToJSON)),
        'InfrastrucureExposure': value.infrastrucureExposure === undefined ? undefined : ((value.infrastrucureExposure as Array<any>).map(InfrastrucureExposureResponseViewModelToJSON)),
        'ActualAssetClassExposureWeigths': ActualAssetClassExposureWeightsViewModelToJSON(value.actualAssetClassExposureWeigths),
        'ActualRegionalExposureWeights': ActualRegionalExposureWeightsViewModelToJSON(value.actualRegionalExposureWeights),
        'InfrastrucureExposureWeights': InfrastructureExposureWeightsViewModelToJSON(value.infrastrucureExposureWeights),
        'ActualAssetClassExposureMaxLimits': ActualAssetClassExposureMaxLimitViewModelToJSON(value.actualAssetClassExposureMaxLimits),
        'InfrastrucureExposureMaxLimits': InfrastructureExposureMaxLimitViewModelToJSON(value.infrastrucureExposureMaxLimits),
        'ActualRegionalExposureMaxLimits': ActualRegionalExposureMaxLimitViewModelToJSON(value.actualRegionalExposureMaxLimits),
    };
}

